export default {
  invoices: (state) => {
    return state.invoices;
  },
  invoicesTotalCount: (state) => {
    return state.invoicesTotalCount;
  },
  keys: (state) => {
    return state.keys;
  },
};
